<script lang="ts">    
    export let label = '';
    export let value = '';  
    export let note = '';
</script>
<style lang="scss">
    .resultlabel{
        font-family: Open Sans;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0px;
        text-align: center;
        color: #000000;
        margin: 16px 0px 0px;
    }
    .value{
        font-family: Open Sans;
        font-size: 26px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-align: center;
        color: #000000;
        margin: 8px auto 24px;
    }    
</style>

<div class='resultlabel'>
    {label} <sup>{note}</sup>
</div>   
<div class="value">
    {value}         
</div>

   